import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId:              process.env.REACT_APP_AZURE_CLIENT_ID,
    authority:             `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri:           `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation:           'localStorage',   // changed from sessionStorage
    storeAuthStateInCookie:  true,             // needed for some browsers
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (process.env.NODE_ENV === 'development') {
          console.log(`[MSAL] ${message}`);
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: ['https://graph.microsoft.com/User.Read'],
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL before anything else runs
export const initializeMsal = async () => {
  await msalInstance.initialize();
  return msalInstance;
};
